import { TranslatedText } from "@/components/common/text";
import { RadioCircle } from "@/components/common/inputs";
import { buildStrategyPills } from "./strategyPills";

const StrategyRadio = ({ checked, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className="flex items-center justify-center w-6 h-6 shrink-0"
        aria-pressed={checked}
        aria-label="Toggle strategy filters"
    >
        <RadioCircle selected={checked} />
    </button>
);

// Two pill styles distinguish the source of each filter:
//   - global → outlined (shared strategy)
//   - truck  → filled   (driver-specific strategy overriding global)
const Pill = ({ children, source, muted }) => {
    const sourceClass =
        source === "truck"
            ? "bg-cm-p-surface-container border-[1.5px] border-transparent"
            : "bg-cm-p-surface border-[1.5px] border-cm-p-outline";
    return (
        <span
            className={`flex items-center justify-center px-[12px] py-[6px] rounded-[58px] whitespace-nowrap text-[14px] font-medium text-cm-p-text-primary ${sourceClass} ${
                muted ? "opacity-50" : ""
            }`}
        >
            {children}
        </span>
    );
};

export const StrategyPillRow = ({
    truckPrefill,
    globalPrefill,
    scopeLabel = "Driver's strategy",
    filtersEnabled = true,
    onToggleFilters,
    bordered = true,
}) => {
    const pills = buildStrategyPills(truckPrefill, globalPrefill);
    if (pills.length === 0) return null;

    return (
        <div
            className={`flex flex-col gap-1 pl-[12px] pr-[16px] py-[8px] rounded-[8px] ${
                bordered ? "border border-cm-p-outline" : ""
            }`}
        >
            {bordered && (
                <span className="text-[12px] font-normal text-cm-p-text-secondary">
                    <TranslatedText>Dynamic filters from strategies</TranslatedText>
                </span>
            )}

            <div className="flex items-center gap-[12px]">
                <StrategyRadio checked={filtersEnabled} onClick={onToggleFilters} />

                <div className="flex-1 min-w-0 overflow-x-auto">
                    <div className="flex items-center gap-[8px] py-[2px]">
                        {pills.map((pill, idx) => (
                            <Pill key={`${pill.label}-${idx}`} source={pill.source} muted={!filtersEnabled}>
                                <TranslatedText>{pill.label}</TranslatedText>
                            </Pill>
                        ))}
                    </div>
                </div>

                <span className="shrink-0 text-[12px] font-normal text-cm-p-text-secondary whitespace-nowrap">
                    <TranslatedText>{scopeLabel}</TranslatedText>
                </span>
            </div>
        </div>
    );
};
